import assert from 'assert';
import {useState, useEffect, useRef, useCallback, ChangeEvent} from 'react';
import classNames from 'classnames';
import sdk from '@/sdk';
import {getAttrs} from '@/utils/arrGetAttrUtil';
import * as store from '@/store';
import Avatar, {AvatarSize} from '@/components/Avatar';
import styles from './index.module.scss';
import toast, {ToastType} from '@/components/Toast';
import {useIntl} from 'react-intl';
import GiveCoin from '@/assets/img/giveCoin.png';
import CoinDeposit from '@/assets/svg/docCoinAndLiked.svg';
import {DocFirstGuide, DocSecondGuide} from '@/components/guide/HomeKnowledgeGuide/';
import Anchor, {OpenType} from '@/components/Anchor';
import routers, {buildPath} from '@/config/routers';
import {WizKnownError} from '@/sdk/common/error';
import {Popper, PopperTrigger} from '@baidu/luffy-comp-popper';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';
import TextArea from '@/components/TextArea';
import Icon, {IconSize} from '@/components/Icon';
import leftTopSvg from '@/assets/svg/leftTop.svg?tsx';
import rightBottomSvg from '@/assets/svg/rightBottom.svg?tsx';
import coinPraiseSvg from '@/assets/svg/coinPraise.svg?tsx';
import selectPraise from '@/assets/svg/selectPraise.svg?tsx';

import {personalPageKnowledgeCoinSendSuccess} from '@/buried/home';
import {
    STATUS,
} from '@/Constant';
import {TooltipTrigger} from '@/components/Tooltip';
import {Tooltip} from '@baidu/luffy';
import ContributorList from './ContributorList';
import {useHistory} from 'react-router-dom';
import eventBus, {DEPOSIT_KNOWLEDGE_COIN} from '@/eventBus';
import {showMysteryBox} from './MysteryBoxDialogUpgrade';
import ThanksSentenceToast, {SENT_COIN_SUCCESS_STATUS} from './ThanksSentenceUpgrade';
interface CoinProps {
    creatorGuid: string;
    creatorName: string;
    docGuid: string;
    repository: Repository;
    className?: string;
}

const ERROR_CODE = {
    fail: '50551',
    notSelf: '50552',
    already: '50553',
    noCoin: '50554',
    illegalTitle: '50563',
    blankContent: '50564',
};


const ANIMATE_STATE = {
    none: 'none',
    in: 'in',
    out: 'out',
};

const praiseList = [{
    content: '协作愉快！',
    emoji: '[机制]',
    type: 1,
}, {
    content: '内容专业易懂！',
    emoji: '[机制]',
    type: 1,
}, {
    content: '有用的知识！',
    emoji: '[机制]',
    type: 1,
}, {
    content: '写的真好，鼓励一下！',
    emoji: '[机制]',
    type: 2,
}, {
    content: '结构清晰，快速get重点！',
    emoji: '[机制]',
    type: 2,
}, {
    content: '用心程度满分！',
    emoji: '[机制]',
    type: 1,
}, {
    content: '好文推荐！',
    emoji: '[机制]',
    type: 1,
}, {
    content: '谢谢分享！',
    emoji: '[机制]',
    type: 1,
}, {
    content: '内容总结到位，点赞！',
    emoji: '[机制]',
    type: 2,
}, {
    content: '干货满满，好牛！',
    emoji: '[机制]',
    type: 2,
}];

const BounsStatusWithStyle = {
    [SENT_COIN_SUCCESS_STATUS.nothing]: 'thanks',
    [SENT_COIN_SUCCESS_STATUS.one]: 'giftThanks',
    [SENT_COIN_SUCCESS_STATUS.two]: 'giftThanks',
};

const {
    useIsInGray: useIsCoinPraiseGray,
} = initGray(GRAY_RELEASE_KEYS.coinPraise);

const useGiveCoinAnimate = () => {
    const [state, setState] = useState(ANIMATE_STATE.none);

    const start = useCallback(() => {
        if (state === ANIMATE_STATE.none) {
            setState(ANIMATE_STATE.in);
            setTimeout(() => {
                setState(ANIMATE_STATE.out);
            }, 2400);
        }
    }, [state]);

    return [state, start];
};

const MAX_LENGTH = 60;

const KnowledgeCoin = (props: CoinProps) => {
    const intl = useIntl();
    const {repository, docGuid, creatorGuid, creatorName, className} = props;
    assert(repository);
    const {userGuid, repositoryGuid} = repository;
    const [docUserGuid, setDocUserGuid] = useState('');
    const [nickname, setNickname] = useState('');
    const [docCoinNum, setDocCoinNum] = useState(0);
    const [isCoin, setIsCoin] = useState(false);
    const [coinList, setCoinList] = useState<any[] | null>(null);
    const docFirstGuideRef = useRef();
    const flag = useRef(false);
    const [coinAnimate, startCoinAnimate] = useGiveCoinAnimate();
    const [currentBounsStatus, setCurrentBounsStatus] = useState(SENT_COIN_SUCCESS_STATUS.nothing);
    const personalHomeRulesUrl = routers.PersonalHome.knowledgeStarHelp;
    const history = useHistory();

    const [tipVisible, setTipVisible] = useState(false);
    const [usableKnowLedgeCoinNum, setUsableKnowLedgeCoinNum] = useState(0);
    const [usableKnowLedgeCoinStatus, setUsableKnowLedgeCoinStatus] = useState('');
    const usableKnowLedgeCoinUrl = `${personalHomeRulesUrl}?type=usableKnowLedgeCoin`;
    const [popperVisible, setPopperVisible] = useState(false);
    const isCoinPraiseGray = useIsCoinPraiseGray();
    const coinPraiseRef = useRef<HTMLDivElement>(null!);
    const [textAreaValue, setTextAreaValue] = useState('');
    const [coinComment, setCoinComment] = useState('');
    const [hasQuickPraise, setHasQuickPraise] = useState(false);
    const [textAreaFocus, setTextAreaFocus] = useState(false);


    // useEffect(() => {
    //     showMysteryBox({
    //         receiverUserGuid: creatorGuid,
    //         receiverName: creatorName,
    //         boxGuid: 'dddddd',
    //         ...repository,
    //     });
    // }, [creatorGuid, creatorName, repository]);

    // 获取币列表
    useEffect(() => {
        // 知识币列表结构
        const coinListDom = (member: any) => {
            return (
                <div className={
                    styles.coinsListWrap
                }
                >
                    <Avatar
                        size={AvatarSize.XS}
                        userGuid={member.userGuid}
                    />
                    <div className={
                        styles.coinsListItemInfo
                    }
                    >
                        <p className={
                            styles.coinsListItemTitle}
                        >
                            <span>
                                {member.nickname}
                            </span>
                            <span className={
                                styles.coinsListItemDepart}
                            >
                                {member.department}
                            </span>
                        </p>
                        <p className={
                            styles.coinsListItemEmail}
                        >
                            {member.email}
                        </p>
                    </div>
                </div>
            );
        };

        async function getCoinsList() {
            try {

                // 知识币列表的所有数据
                const ksServer = await sdk.getKsServer(repository);
                const docCoins = await ksServer.giveCoinsList(docGuid) || [];
                setDocCoinNum(docCoins.length);
                // 将知识币的更新同步到store
                store.setCurDocKnowledgeCoin(docCoins.length);
                // 判断当前用户是否已经进行知识币, 提升到获取用户信息之前
                const isHasCoin = docCoins.find(item => {
                    return item.giverUserGuid === sdk.as.user?.userGuid;
                });
                setIsCoin(!!isHasCoin);
                store.setIsDepositKnowledgeCoin(!!isHasCoin);
                // 拿到所有的Guid去批量请求完整的知识币列表的数据
                const userGuidList = getAttrs(docCoins, 'giverUserGuid');
                const usersList = await sdk.as.getUserInfoList(userGuidList.slice(0, 200), false); // 截断取前200个
                const sortUsersList = (usersList: any[]) => {
                    return usersList.sort((a, b) => {
                        return userGuidList.indexOf(a.userGuid) - userGuidList.indexOf(b.userGuid);
                    });
                };
                const result = sortUsersList(usersList);
                // 设置DropMenu组件的数据格式
                if (result && result.length > 0) {
                    const options = result.map(member => {
                        return {
                            label: coinListDom(member),
                            value: member.userGuid,
                            name: member.avatar,
                        };
                    });
                    // setCoinList((new Array(100)).fill(options[0]));
                    setCoinList(options);
                }
                else {
                    setCoinList([]);
                }
            } catch (error) {
                // console.error(error);
            }
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        // getCoinInfo();
        getCoinsList();
        // 根据isCoin的更改做变化，因为isCoin如果更改的话，自己进行了知识币/取消知识币的动作, 对应的币列表也要做变化
    }, [docGuid, repositoryGuid, repository, isCoin, userGuid]);

    function handleBeforeChange(visible: boolean) {
        setTipVisible(visible);
    }
    // 获取可用知识币
    const getCurUserCoinInfo = useCallback(async () => {
        try {
            const {userCoinInfo} = await sdk.as.queryUserCoinInfo();
            setUsableKnowLedgeCoinNum(userCoinInfo?.availableCoinCount);
        } catch (err) {
            setUsableKnowLedgeCoinStatus(STATUS.error);
            console.log(err);
        }
    }, []);

    useEffect(() => {
        getCurUserCoinInfo();
    }, [getCurUserCoinInfo]);

    const handleClickToastAnchor = useCallback(() => {
        window.open(personalHomeRulesUrl);
    }, [personalHomeRulesUrl]);

    // 没有知识币时，弹出提示框
    const notHaveCoinToast = useCallback(() => {
        toast({
            content: <div className={styles.noCoinToast}>
                <span>您本周的知识币已用完，</span>
                <a
                    className={styles.noCoinToastAnchor}
                    onClick={handleClickToastAnchor}
                >
                    了解如何获得更多知识币
                </a>
            </div>,
            type: ToastType.Error,
        });
    }, [handleClickToastAnchor]);

    // 获取投币夸赞
    const getCoinComment = useCallback(async () => {
        try {
            const ksServer = await sdk.getKsServer(repository);
            const res = await ksServer.getCoinComment(docGuid);
            setCoinComment(res.comment);
        }
        catch (error) {
            console.error(error);
        }
    }, [repository, docGuid]);

    // 对页面赠送
    const giveCoin = useCallback(async (hasPraise?: boolean) => {
        try {
            if (flag.current) {
                return;
            }
            flag.current = true;
            const ksServer = await sdk.getKsServer(repository);
            const {
                bonusCoinCount = 0,
                blindBox,
                docShare,
            } = await ksServer.giveCoins(docGuid, hasPraise ? textAreaValue : '');
            setCurrentBounsStatus(bonusCoinCount);

            flag.current = false;
            setIsCoin(true);
            // 赠送成功再重新获取可用知识币
            setTipVisible(false);
            getCurUserCoinInfo();
            const hasMsg = textAreaValue ? '1' : '0';
            const msgType = hasQuickPraise ? '0' : '1';
            // 赠送成功埋点
            personalPageKnowledgeCoinSendSuccess(
                docGuid,
                repository?.repositoryGuid,
                repository?.groupGuid,
                sdk.user!.userGuid,
                sdk.user!.nickname,
                hasMsg,
                msgType
            );
            if (blindBox) {
                showMysteryBox({
                    receiverUserGuid: creatorGuid,
                    receiverName: creatorName,
                    boxGuid: blindBox.boxGuid,
                    docShare: docShare,
                    ...repository,
                });
            } else {
                ThanksSentenceToast({creatorGuid, creatorName, status: bonusCoinCount, docShare}, history);
            }
            if (typeof startCoinAnimate !== 'string') {
                startCoinAnimate();
            }
        } catch (error) {
            flag.current = false;
            if (error instanceof WizKnownError) {
                if ([
                    ERROR_CODE.already,
                    ERROR_CODE.fail,
                    ERROR_CODE.notSelf,
                    ERROR_CODE.blankContent,
                    ERROR_CODE.illegalTitle,
                ].includes(`${error.code}`)) {
                    toast({
                        content: error.message,
                        type: ToastType.Error,
                    });
                    return error.code;
                } else if (`${error.code}` === ERROR_CODE.noCoin) {
                    notHaveCoinToast();
                    return error.code;
                }
            }
            toast({
                content: intl.formatMessage({id: 'toastGiveCoinError'}),
                type: ToastType.Error,
            });
        }
        setPopperVisible(false);
    }, [intl,
        history,
        docGuid,
        repository,
        creatorGuid,
        creatorName,
        startCoinAnimate,
        getCurUserCoinInfo,
        textAreaValue,
        hasQuickPraise,
        notHaveCoinToast,
    ]);

    useEffect(() => {
        eventBus.on(DEPOSIT_KNOWLEDGE_COIN, giveCoin);
        return () => {
            eventBus.off(DEPOSIT_KNOWLEDGE_COIN, giveCoin);
        };
    }, [giveCoin]);

    // 当前用户是不是该文档的创建人
    const isMyself = creatorGuid === sdk.user?.userGuid;

    const handleClickCoin = useCallback(() => {
        // 没有知识币时，弹出提示框
        if (usableKnowLedgeCoinNum === 0 && !isCoin) {
            notHaveCoinToast();
            return;
        }
        if (isCoinPraiseGray) {
            setPopperVisible(true);
            // 解决文档第一次进入时，store中没有document数据，导致用户头像为空，
            // 点击送币按钮时再获取document数据
            const document = store.getData(store.KEYS.CUR_DOCUMENT);
            setNickname(document?.nickname);
            setDocUserGuid(document?.userGuid);
            return;
        }
        // if (typeof startCoinAnimate !== 'string') {
        //     startCoinAnimate();
        // }
        // 当前点击：关闭新手弹窗->DocFirstGuide组件暴露出的方法
        (docFirstGuideRef.current as any).onAction();

        // 给自己送
        if (isMyself) {
            toast({
                content: intl.formatMessage({id: 'toastGiveCoinNoSelf'}),
                type: ToastType.Error,
            });
            return;
        }

        // 送过的
        if (isCoin) {
            toast({
                content: intl.formatMessage({id: 'toastGiveCoinAlready'}),
                type: ToastType.Error,
            });
            return;
        }
        giveCoin();
    }, [isMyself, isCoin, giveCoin, intl, isCoinPraiseGray, usableKnowLedgeCoinNum, notHaveCoinToast]);

    // 弹窗状态变换
    const onChange = (visible: boolean) => {
        if (!visible) {
            setPopperVisible(false);
            setTextAreaValue('');
            setHasQuickPraise(false);
            setTextAreaFocus(false);
        }
    };

    const handleTextAreaChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        setTextAreaValue(e.target.value);
    };

    // 点击快捷评论
    const hanlePraiseClick = (data: any) => {
        setHasQuickPraise(true);
        setTextAreaValue(value => {
            const newValue = `${value}${data.content}`;
            if (newValue.length > 60) {
                toast({
                    content: '限制输入60个字',
                    type: ToastType.Error,
                });
                return value;
            } else {
                return newValue.slice(0, 60);
            }
        });
    };

    const handleKeyDown = useCallback((e: any) => {
        // 屏蔽方向键、回车、tab、shift、ctrl、alt、meta等按键
        const isArrow = e.keyCode >= 37 && e.keyCode <= 40;
        const isFunction = e.keyCode >= 8 && e.keyCode <= 20;
        if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || isArrow || isFunction) {
            return;
        }

        if (textAreaValue.length >= 60) {
            toast({
                content: '限制输入60个字',
                type: ToastType.Error,
            });
        }
    }, [textAreaValue]);

    // 点击弹窗内投币
    const handleCoinClick = useCallback(() => {
        giveCoin(true);
    }, [giveCoin]);

    // 已投过币的文档，获取夸赞评论
    useEffect(() => {
        isCoin && getCoinComment();
    }, [isCoin, getCoinComment]);

    useEffect(() => {
        // 判断投币icon是否在可视窗口内，不在可视窗口内，则隐藏弹窗
        const editorContainer = document.querySelector('.mp-layout-content-container');
        const handleScroll = () => {
            // 可视窗口有6-7像素误差，所以需要减去6像素
            const editorHeight = editorContainer!.getBoundingClientRect().height - 6;
            const coinTop = coinPraiseRef.current.getBoundingClientRect().top;
            const coinHeight = coinPraiseRef.current.getBoundingClientRect().height;
            // coinTop - coinHeight > editorHeight 计算投币icon的顶部是否显示
            // coinTop < -6 计算投币icon的底部部是否显示
            if (coinTop - coinHeight > editorHeight || coinTop < -6) {
                setPopperVisible(false);
            }
        };
        if (popperVisible) {
            editorContainer!.addEventListener('scroll', handleScroll);
        } else {
            editorContainer!.removeEventListener('scroll', handleScroll);
        }
        return () => editorContainer!.removeEventListener('scroll', handleScroll);
    }, [popperVisible]);

    return (
        <div className={classNames(
            styles.coinWrap,
            className
        )}
        >
            {/* 知识币 */}
            <div className={styles.coinWrapCont}>
                <DocFirstGuide ref={docFirstGuideRef}>
                    <DocSecondGuide>
                        <PopperTrigger
                            visible={popperVisible}
                            target={coinPraiseRef.current}
                            onChange={onChange}
                        >
                            <Tooltip
                                trigger={TooltipTrigger.Hover}
                                placement="top"
                                visible={tipVisible}
                                beforeChange={handleBeforeChange}
                                content={
                                    !popperVisible && <div className={styles.usableKnowLedgeCoin}>
                                        {
                                            // eslint-disable-next-line no-negated-condition
                                            usableKnowLedgeCoinStatus !== STATUS.error ?
                                                <>
                                                    <div>
                                                        您本周可用知识币：{usableKnowLedgeCoinNum}枚
                                                    </div>
                                                    {
                                                        // eslint-disable-next-line no-negated-condition
                                                        isCoin ?
                                                            <div>
                                                                您已投过啦，去给其他好文投吧～
                                                            </div> :
                                                            usableKnowLedgeCoinNum ?
                                                                <div>
                                                                    给 {creatorName} 送枚知识币吧～
                                                                </div> :
                                                                <div>
                                                                    去<Anchor
                                                                        className={styles.knowLedgeCoinDetail}
                                                                        url={usableKnowLedgeCoinUrl}
                                                                        openType={OpenType.newTab}
                                                                    >
                                                                        知识币详情
                                                                    </Anchor>查看如何获取更多可用的知识币～
                                                                </div>
                                                    }

                                                </> :
                                                <div>
                                                    给 {creatorName} 送枚知识币吧～
                                                </div>
                                        }

                                    </div>
                                }
                            >
                                <div
                                    className={classNames(
                                        styles.coinIconBg,
                                        isCoin && styles.coinActiveIconBg
                                    )}
                                    onClick={handleClickCoin}
                                    id="knowledgeCoinId"
                                    ref={coinPraiseRef}
                                >
                                    {
                                        coinAnimate !== ANIMATE_STATE.in && <div>
                                            <img src={GiveCoin} />
                                            {isCoin && <img className={styles.coinDeposit} src={CoinDeposit} />}
                                        </div>
                                    }
                                    <div className={styles.coinIconBgShadow} id="coinIconBgShadow"></div>
                                </div>
                            </Tooltip>
                            <Popper
                                placement={'top'}
                                className={styles.popperWrap}
                                withArrow
                            >
                                {!isCoin ?
                                    <div className={styles.popperContent}>
                                        <div className={styles.popperTitle}>
                                            <span>给</span>
                                            <Avatar
                                                size={AvatarSize.XS}
                                                userGuid={docUserGuid}
                                                className={styles.avatarIcon}
                                            />
                                            <span className={styles.userName}>{nickname}</span>
                                            <span>的这篇文档送枚知识币吧！</span>
                                        </div>
                                        <TextArea
                                            maxLength={MAX_LENGTH}
                                            value={textAreaValue}
                                            onChange={handleTextAreaChange}
                                            allowOverflow={false}
                                            placeholder={'写下你的投币理由，你的夸赞是对创作者最好的鼓励'}
                                            className={classNames(
                                                styles.inputMarginLeft,
                                                textAreaFocus && styles.textAreaFocus,
                                                textAreaValue.length >= MAX_LENGTH && styles.textAreaError
                                            )}
                                            onFocus={() => {setTextAreaFocus(true);}}
                                            onBlur={() => {setTextAreaFocus(false);}}
                                            size={'md'}
                                            onKeyDown={handleKeyDown}
                                            closeBuffer
                                            autoFocus
                                        />
                                        <div className={styles.popperList}>
                                            {
                                                praiseList.map((item: any) => {
                                                    return (
                                                        <div
                                                            className={classNames(
                                                                styles.listItem,
                                                                item.type === 1 && styles.shortItme
                                                            )}
                                                            key={item.content}
                                                            onClick={() => hanlePraiseClick(item)}
                                                        >
                                                            <div className={styles.itemContent}>{item.content}</div>
                                                            <Icon svg={selectPraise} />
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                        <div className={styles.popperBottom}>
                                            <div className={styles.bottomTips}>
                                                <span>本周可用知识币:</span>
                                                <span className={styles.coinNum}>{usableKnowLedgeCoinNum}</span>
                                                <span>枚</span>
                                            </div>
                                            <div
                                                className={styles.popperBtn}
                                                onClick={handleCoinClick}
                                            >
                                                <Icon svg={coinPraiseSvg} size={IconSize.LG} />
                                                <div className={styles.btnName}>投币给ta</div>
                                            </div>
                                        </div>
                                    </div> :
                                    <div className={styles.coinInsertedBox}>
                                        {
                                            coinComment ?
                                                <div className={styles.coinTitle}>
                                                    您投过币并且夸了ta～，快去给其他好文投吧！
                                                </div> :
                                                <div className={styles.coinTitle}>
                                                    您投过币啦～，快去给其他好文投吧！
                                                </div>
                                        }
                                        {
                                            coinComment ?
                                                <div className={styles.commentBox}>
                                                    <Icon
                                                        className={styles.leftIcon}
                                                        svg={leftTopSvg}
                                                    />
                                                    <div className={styles.coinComment}>{coinComment}</div>
                                                    <Icon
                                                        className={styles.rightIcon}
                                                        svg={rightBottomSvg}
                                                    />
                                                </div> :
                                                <div className={classNames(
                                                    styles.commentBox,
                                                    styles.noComment)}
                                                >
                                                    你本次没有夸奖，喜欢内容请多鼓励一下呀！
                                                </div>
                                        }
                                        <div className={styles.popperBottom}>
                                            <div
                                                className={styles.popperBtn}
                                            >
                                                <Icon svg={coinPraiseSvg} size={IconSize.LG} />
                                                <div className={styles.btnName}>已投币</div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </Popper>
                        </PopperTrigger>
                    </DocSecondGuide>
                </DocFirstGuide>
                {
                    coinAnimate === ANIMATE_STATE.in && <div className={styles.coinGif}></div>
                }
                {
                    coinAnimate !== ANIMATE_STATE.none &&
                    <div className={classNames(
                        styles[BounsStatusWithStyle[currentBounsStatus]],
                        'animated',
                        'delay-1s',
                        coinAnimate === ANIMATE_STATE.in && 'bounceInUp',
                        coinAnimate === ANIMATE_STATE.out && 'fadeOut'
                    )}
                    >

                    </div>
                }
                <ContributorList
                    docCoinNum={docCoinNum}
                    isMyself={isMyself}
                    intl={intl}
                    coinList={coinList}
                    personalHomeRulesUrl={personalHomeRulesUrl}
                />
            </div>
        </div>
    );
};

export default store.connect([
    store.KEYS.PERSONAL_HOME_USER_GUID,
])(KnowledgeCoin);
